import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_calendar",
  "use": "icon_calendar-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_calendar\"><path d=\"M18.3636 4V8.32M9.63636 4V8.32M6 10.48H22M6 6.16H22V22H6V6.16Z\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol